import { useAsertoApiWithAuth } from '@aserto/console-common'

import { useClientConfig } from '../services/EnvConfigProvider'

export function useInternalClient() {
  const envConfig = useClientConfig()
  const discoveryServiceUrl = envConfig.isDocker
    ? window.location.origin
    : envConfig.discoveryServiceUrl
  return useAsertoApiWithAuth(`${discoveryServiceUrl}/api/v2`)
}
